/** Adds dnt=1 to Vimeo player iframe URLs in CMS embed HTML. */
export function withVimeoDnt(html: string): string {
  return html.replace(
    /(https?:\/\/player\.vimeo\.com\/video\/[^"'\s?]+)(\?[^"'\s>]*)?/gi,
    (match, base, query) => {
      if (query && /(?:^|[&?])dnt=1(?:&|$)/i.test(query)) return match
      return base + (query ? query + "&dnt=1" : "?dnt=1")
    }
  )
}
